import React from "react";
import { useDecision } from "@optimizely/react-sdk";
import { OPTIMIZELY_FLAGS } from "config/optimizely";
import loadable from "@loadable/component";

// Code split V1 and V2 directly (not through Bundles.js to avoid circular dependency)
// Users only download the variant they see
const SearchPageV1 = loadable(() =>
	import(
		/* webpackChunkName: "SearchPageV1" */ "../SearchPageV1/SearchPageV1"
	)
);
const SearchPageV2 = loadable(() =>
	import(
		/* webpackChunkName: "SearchPageV2" */ "../SearchPageV2/SearchPageV2"
	)
);

/**
 * SearchPage Wrapper - A/B Test Controller
 *
 * This component acts as a router between SearchPageV1 (legacy) and SearchPageV2 (new design).
 * It uses Optimizely feature flags to determine which version to render.
 *
 * Decision logic:
 * - If OPTIMIZELY_FLAGS.CLP_TESTING is enabled → Show SearchPageV2 (new)
 * - If disabled or flag doesn't exist → Show SearchPageV1 (legacy)
 *
 * This architecture provides:
 * - Clean separation of concerns
 * - No CSS conflicts between versions
 * - Single decision point for A/B testing
 * - Easy rollback/rollforward capabilities
 */
export default function SearchPage() {
	const [decision] = useDecision(OPTIMIZELY_FLAGS.CLP_TESTING);

	if (decision?.enabled) {
		return <SearchPageV2 />;
	}

	return <SearchPageV1 />;
}
